module.exports = __webpack_public_path__ + "static/007.thumb-7ae5e6752e7159186d69bf15a37ec6f5.jpg";